export const preload = function (srcs) {
  if (typeof srcs != 'array') {
    srcs = [srcs]
  }
  return Promise.all(
    srcs.map((src, index) => {
      return new Promise((resolve) => {
        const img = new Image()
        img.onload = function () {
          resolve({ index, src, width: this.width, height: this.height })
        }
        img.src = src
      })
    })
  )
}
